import axios from 'axios';

import { periodsConstants } from '../constants';

export const periodsActions = {
    getPeriods,
    getExpandedPeriods,
    setExpandedPeriods,
};

function getPeriods() {
    return async (dispatch) => {
        dispatch(request());

        try {
            const response = await axios.get('/periods');
        

            if (response.status === 200) dispatch(success(response.data));
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            console.error(error);
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to get the periods at this moment'));
            }
        }

        function request() {
            return { type: periodsConstants.GET_PERIODS_REQUEST };
        }
        function success(periods) {
            return { type: periodsConstants.GET_PERIODS_SUCCESS, periods };
        }
        function failure(error) {
            return { type: periodsConstants.GET_PERIODS_FAILURE, error };
        }
    };
}

function getExpandedPeriods() {
    
    return async (dispatch) => {
        dispatch(request());

        try {
            const organizationUrl = '/organization/';
            const response = await axios.get(organizationUrl);
            const organization = response.data;

            if (response.status === 200) {
                let newExpandedPeriods = [];
                              
                [...organization.expanded_periods].forEach((expandedPeriod) => {
                    if (expandedPeriod === 'M') {
                        newExpandedPeriods = newExpandedPeriods.concat(Array(13).fill(true));
                    } else if (expandedPeriod === 'Q') {
                        newExpandedPeriods = newExpandedPeriods.concat(Array(5).fill(true));
                    } else {
                        newExpandedPeriods.push(true);
                    }
                });
                dispatch(success(newExpandedPeriods));
                
            }
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            if (console.error(error)) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to get expanded periods at this moment'));
            }
        }

        function request() {
            return { type: periodsConstants.GET_EXPANDED_PERIODS_REQUEST };
        }
        function success(expandedPeriods) {
            return {
                type: periodsConstants.GET_EXPANDED_PERIODS_SUCCESS,
                expandedPeriods,
            };
        }
        function failure(error) {
            return {
                type: periodsConstants.GET_EXPANDED_PERIODS_FAILURE,
                error,
            };
        }
    };
}

function setExpandedPeriods(expandedPeriods) {
    return async (dispatch) => {
        dispatch(request());

        try {
            dispatch(success(expandedPeriods));
        } catch (error) {
            if (console.error(error)) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to set expanded periods at this moment'));
            }
        }

        function request() {
            return { type: periodsConstants.SET_EXPANDED_PERIODS_REQUEST };
        }
        function success(expandedPeriods) {
            return {
                type: periodsConstants.SET_EXPANDED_PERIODS_SUCCESS,
                expandedPeriods,
            };
        }
        function failure(error) {
            return {
                type: periodsConstants.SET_EXPANDED_PERIODS_FAILURE,
                error,
            };
        }
    };
}
